export default __webpack_public_path__ + "static/media/Cronos-Pro-Light-Subhead.18e1f68b.ttf";